<template>
    <div class="hello">
        <table border strip class="info-table">
            <tr>
                <th>序号</th>
                <th>类型</th>
                <th>发起时间</th>
                <th>审核状态</th>
                <th>审核时间</th>
                <th>操作</th>
            </tr>
            <tr v-for="(a, i) in audits.list" :key="i">
                <td>{{i+1}}</td>
                <td>{{a.typeName || a.bigTypeName}}</td>
                <td>{{a.launchDate}}</td>
                <td>{{a.statusName}}</td>
                <td>{{a.approveDate}}</td>
                <td>
                    <a @click.prevent="view(a)" class="edit-btn">查看</a>
                </td>
            </tr>
            <tr v-if="!audits.list.length"><td colspan=10>暂无数据</td></tr>
        </table>

        <el-dialog title="审核详情" :visible.sync="auditDialogVisible" :width="'80%'">
            <table border strip class="info-table">
                <tr>
                    <th>序号</th>
                    <th>修改字段名称</th>
                    <th>调整前</th>
                    <th>调整后</th>
                    <th>发起审核时间</th>
                    <th>审核状态</th>
                    <th>审核说明</th>
                    <th>审核时间</th>
                </tr>
                <tr v-for="(a,i) in changeEntitys" :key="i">
                    <td>{{i+1}}</td>
                    <td>{{a.fchangeitem}}</td>
                    <td class="break-word">{{a.foldval}}</td>
                    <td class="break-word">{{a.fnewval}}</td>
                    <td>{{a.createDate}}</td>
                    <td>{{ a.auditStatus?adjustStatus[a.auditStatus]:'审批中' }}</td>
                    <td>{{a.approveRemark}}</td>
                    <td>{{a.auditDate}}</td>
                </tr>
            </table>
            <div slot="footer" class="dialog-footer text-center">
                <el-button @click="auditDialogVisible = false" type="primary">关 闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script type="text/babel">
    import { mapGetters, mapActions } from 'vuex'
    import filter from '@/filter'

    export default {
        name: 'supplier-audit',
        data () {
            return {
                changeEntitys: [],
                auditDialogVisible: false
            }
        },
        computed: mapGetters(['audits', 'adjustStatus']),
        methods: {
            ...mapActions(['getAuditRes']),
            view(audit){
                this.getAuditDetail(audit.bizTablePkValue).then(res=>{
                    const data = res.data
                    if(data.result){
                        this.changeEntitys = data.value
                        this.auditDialogVisible = true
                    }else{
                        this.$alert(data.message)
                    }
                }).catch(err=>this.$alert(err))

            },
            getAuditDetail(id){
                return this.$http.get(`/rest/api/completeFourInfo/getDetailChanges/${id}`)
            }
        },
        filters: filter,
        created(){
            this.$root.loading = true
            this.getAuditRes().then((r)=>this.$root.loading = false)
                                .catch((err)=>this.$root.loading = false)
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/dsp/supplier/Audit.vue